export default {
  name: 'ToggleComponent',
  props: {
    active: {
      type: Boolean,
      "default": false
    }
  }
};